import { render, staticRenderFns } from "./LegendRight.vue?vue&type=template&id=a1a4ff08&"
import script from "./LegendRight.vue?vue&type=script&lang=js&"
export * from "./LegendRight.vue?vue&type=script&lang=js&"
import style0 from "./LegendRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports